module.exports = __webpack_public_path__ + "img/game_2_1.8f69de69.png";